module.exports = __webpack_public_path__ + "img/SMT_49 Mr_Louis_Chui_Kian_Hong.30960705.jpg";